import { render, staticRenderFns } from "./TabMemberPurchaseRecord.vue?vue&type=template&id=dd52ae1e&"
import script from "./TabMemberPurchaseRecord.vue?vue&type=script&lang=js&"
export * from "./TabMemberPurchaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./TabMemberPurchaseRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports